module.exports = __webpack_public_path__ + "img/mobile_map_curitiba.e632b13c.svg";